export default __webpack_public_path__ + "static/media/AUDI.175d5ec8.png";